import React from 'react';
import { CheckCircleIcon, ClockIcon, HeartIcon, ThumbsUpIcon } from 'lucide-react';
const Benefits = () => {
  return <section className="w-full bg-[#F5EBE0] py-16" data-id="element-20">
      <div className="container mx-auto px-4" data-id="element-21">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#8B4513] mb-6" data-id="element-22">
          🥇 Lo que nadie más te da
        </h2>
        <p className="text-xl text-center text-[#5E4B3C] mb-12 max-w-3xl mx-auto font-medium" data-id="element-23">
          (y por qué esto funciona sin esfuerzo)
        </p>
        <div className="max-w-3xl mx-auto text-center mb-8" data-id="element-24">
          <p className="text-xl font-bold text-[#8B4513] mb-8" data-id="element-25">
            Esto no es un recetario. Es una herramienta de transformación.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-26">
          <div className="flex items-start" data-id="element-27">
            <CheckCircleIcon className="w-6 h-6 text-[#E25822] mr-3 flex-shrink-0 mt-1" data-id="element-28" />
            <p className="text-lg text-[#5E4B3C]" data-id="element-29">
              <span className="font-bold" data-id="element-30">3 ebooks estructurados</span> para
              resultados rápidos
            </p>
          </div>
          <div className="flex items-start" data-id="element-31">
            <CheckCircleIcon className="w-6 h-6 text-[#E25822] mr-3 flex-shrink-0 mt-1" data-id="element-32" />
            <p className="text-lg text-[#5E4B3C]" data-id="element-33">
              <span className="font-bold" data-id="element-34">Técnicas simples</span> con
              ingredientes reales
            </p>
          </div>
          <div className="flex items-start" data-id="element-35">
            <CheckCircleIcon className="w-6 h-6 text-[#E25822] mr-3 flex-shrink-0 mt-1" data-id="element-36" />
            <p className="text-lg text-[#5E4B3C]" data-id="element-37">
              <span className="font-bold" data-id="element-38">Imágenes paso a paso</span> para
              evitar errores
            </p>
          </div>
          <div className="flex items-start" data-id="element-39">
            <CheckCircleIcon className="w-6 h-6 text-[#E25822] mr-3 flex-shrink-0 mt-1" data-id="element-40" />
            <p className="text-lg text-[#5E4B3C]" data-id="element-41">
              <span className="font-bold" data-id="element-42">10 eBooks de bonos irresistibles:</span> tablas
              de quesos, finger foods internacionales, mini postres y más
            </p>
          </div>
        </div>
        <div className="max-w-3xl mx-auto text-center mt-12" data-id="element-43">
          <p className="text-xl text-[#5E4B3C]" data-id="element-44">
            Ya no se trata de cocinar. Se trata de{' '}
            <span className="font-bold text-[#8B4513]" data-id="element-45">destacar</span>. De que
            los ojos brillen al ver tu mesa. De que tus manos sean las autoras
            del asombro.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-16 max-w-5xl mx-auto" data-id="element-46">
          <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-47">
            <HeartIcon className="w-10 h-10 text-[#E25822] mx-auto mb-4" data-id="element-48" />
            <h3 className="text-lg font-bold text-[#8B4513] mb-2" data-id="element-49">
              Impacto Visual
            </h3>
            <p className="text-[#5E4B3C]" data-id="element-50">
              Bocaditos que se roban todas las miradas
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-51">
            <ThumbsUpIcon className="w-10 h-10 text-[#E25822] mx-auto mb-4" data-id="element-52" />
            <h3 className="text-lg font-bold text-[#8B4513] mb-2" data-id="element-53">
              Sabor Excepcional
            </h3>
            <p className="text-[#5E4B3C]" data-id="element-54">
              Recetas que despiertan elogios con el primer mordisco
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-55">
            <ClockIcon className="w-10 h-10 text-[#E25822] mx-auto mb-4" data-id="element-56" />
            <h3 className="text-lg font-bold text-[#8B4513] mb-2" data-id="element-57">
              Ahorro de Tiempo
            </h3>
            <p className="text-[#5E4B3C]" data-id="element-58">
              Técnicas express que optimizan tu preparación
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-59">
            <CheckCircleIcon className="w-10 h-10 text-[#E25822] mx-auto mb-4" data-id="element-60" />
            <h3 className="text-lg font-bold text-[#8B4513] mb-2" data-id="element-61">
              Seguridad Total
            </h3>
            <p className="text-[#5E4B3C]" data-id="element-62">
              Orgullo y poder al presentar tus creaciones
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default Benefits;